import { MenuItem } from '@mui/material';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { getVendorContacts } from '../../fetch';
import { IVendorContact } from '../../models';
import { SMBSelect } from '../input';

interface IVendorContactDropdownProps {
  value: string | number;
  handleChange: (val: any) => void;
  isDisabled?: boolean;
  setOptions?: (val: IVendorContact[]) => void;
  apiParams?: any;
  selectedVendorId: string | number;
  label?: string;
  isRequired?: boolean;
}

export const VendorContactDropdown: FC<IVendorContactDropdownProps> = ({
  isDisabled,
  isRequired,
  label,
  value,
  handleChange,
  setOptions,
  apiParams,
  selectedVendorId
}) => {
  const { isLoading: isLoadingVendorContacts, data: vendorContactsData } = useQuery<
    IVendorContact[],
    Error
  >(['vendors-contacts', selectedVendorId], () => getVendorContacts(selectedVendorId, apiParams), {
    onSuccess: d => setOptions?.(d),
    enabled: !!selectedVendorId,
    notifyOnChangeProps: 'tracked'
  });
  const vendorContacts = useMemo(() => vendorContactsData ?? [], [vendorContactsData]);
  return (
    <SMBSelect
      disabled={
        isDisabled || isLoadingVendorContacts || !vendorContacts || vendorContacts.length === 0
      }
      label={isLoadingVendorContacts ? 'Loading...' : label ?? 'Vendor Contact'}
      required={isRequired}
      id="vendorContact"
      value={value}
      onChange={({ target: { value } }) => {
        handleChange(value);
      }}
      handleClear={() => handleChange('')}
      SelectProps={{
        MenuProps: {
          sx: {
            maxHeight: '30rem'
          }
        }
      }}
    >
      {!isLoadingVendorContacts && vendorContacts && vendorContacts.length === 0 && (
        <MenuItem disabled>No Contacts available</MenuItem>
      )}
      {vendorContacts &&
        vendorContacts.map((contact, index) => {
          return (
            <MenuItem key={`vendor-contact-${contact.personId}`} value={contact.email}>
              {contact.name}
            </MenuItem>
          );
        })}
    </SMBSelect>
  );
};
